import { Controller } from 'stimulus';

export default class extends Controller<HTMLElement> {
  destroyTarget: HTMLInputElement;
  discountTarget: HTMLInputElement;
  intervalTarget: HTMLInputElement;
  planIdTarget: HTMLInputElement;
  priceTarget: HTMLInputElement;
  renewTarget: HTMLInputElement;
  titleTarget: HTMLInputElement;

  static get targets() {
    return [
      'destroy',
      'discount',
      'interval',
      'planId',
      'price',
      'renew',
      'title'
    ];
  }

  remove(evt) {
    evt.preventDefault();

    if (this.element.dataset.id) {
      this.destroyTarget.value = '1';
      this.element.style.display = 'none';
    } else {
      this.element.remove();
    }
  }

  selectPlan(evt) {
    evt.preventDefault();

    const { dataset } = evt.target;
    this.planIdTarget.value = dataset.planid;
    this.priceTarget.value = dataset.price;
    this.titleTarget.value = dataset.title;
    this.discountTarget.value = dataset.discount;
    this.intervalTarget.value = dataset.interval;
    this.renewTarget.checked = dataset.renew === 'true';
  }
}
